import { Grid, Typography, Box } from "@mui/material";
import eSignSuccess from "../../assets/svg/nomine_1.png";
import caution from "../../assets/svg/nomine_2.png";

const ESignSuccess = () => {
  return (
    <Grid container justifyContent="center" spacing={3} padding={{ xs: 2, sm: 3 }}>
      <Grid item xs={12} textAlign="center">
        <Box component="img"
          src={eSignSuccess}
          alt="E-sign success"
          sx={{ maxWidth: { xs: "40%", sm: "25%", md: "15%" }, height: "auto" }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography
          sx={{
            color: "#131E2E",
            fontSize: { xs: "15px", sm: "17px", md: "18px" },
            fontWeight: 600,
            textAlign: "center",
            px: { xs: 2, sm: 4 }
          }}
        >
          We are initiating the registration of nominations with Stock Exchanges and Demat Account with Depository.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box display="flex" alignItems="center" justifyContent="center" gap={2} px={2}>
          <Box component="img" src={caution} alt="Caution" sx={{ width: 30, height: 30 }} />
          <Typography
            sx={{
              color: "#131E2E",
              fontSize: { xs: "14px", sm: "16px" },
              textAlign: "left",
              maxWidth: "80%"
            }}
          >
            This usually takes 24 to 48 hours in registering your nominations.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ESignSuccess;
